import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import 'bootstrap/dist/css/bootstrap.min.css';
import AccountSettings from './components/AccountSettings';
import MarcarFerias from './components/MarcarFerias';
import FaltaPage from './components/FaltaPage';
import EscritorioPage from './components/EscritorioPage';
import FerramentasAdministrativas from './components/FerramentasAdministrativas';
import FerramentasAdmin from './components/FerramentasAdmin';
import ClichesMoldes from './components/ClichesMoldes'; // Nome corrigido
import Corte from './components/Corte'; // Import the Corte page
import Armazem from './components/Armazem'; // Importando a nova página Armazem
import Stocks from './components/Stocks'; // Importando a nova página Armazem
import Home from './components/Home';
import Warehouse from './warehouse'; // Importa a nova página Warehouse
import Digital from './components/Digital';
import WarehouseOp from './warehouse/warehouseop'; // Importe o componente WarehouseOp
import IndexOp from './op/indexop';
import 'primereact/resources/themes/saga-blue/theme.css';  // ou outro tema de sua preferência
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
// Importações dos novos componentes:
import ArtigoPhc from './op/pages/artigo_phc';
import TipoSaco from './op/pages/tipo_saco';
import Tamanho from './op/pages/tamanho';
import TipoImpressao from './op/pages/tipo_impressao';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/account-settings" element={<AccountSettings />} />
                <Route path="/marcar-ferias" element={<MarcarFerias />} />
                <Route path="/faltas" element={<FaltaPage />} />
                <Route path="/escritorio" element={<EscritorioPage />} />
                <Route path="/ferramentas-administrativas" element={<FerramentasAdministrativas />} />
                <Route path="/ferramentasadmin" element={<FerramentasAdmin />} />
                <Route path="/cliches-moldes" element={<ClichesMoldes />} /> {/* Nome corrigido */}
                <Route path="/corte" element={<Corte />} /> {/* Rota correta para Corte */}            
                <Route path="/armazem" element={<Armazem />} /> {/* Nova rota para Armazem */}
                <Route path="/stocks" element={<Stocks />} /> {/* Nova rota para Armazem */}
                <Route path="/digital" element={<Digital />} />
                <Route path="/home" element={<Home />} />
                <Route path="/warehouse" element={<Warehouse />} />
                <Route path="/warehouseop" element={<WarehouseOp />} />  {/* Rota para o dashboard WarehouseOp */}
                <Route path="/config/artigo_phc" element={<ArtigoPhc />} />
                <Route path="/config/tipo_saco" element={<TipoSaco />} />
                <Route path="/config/tamanho" element={<Tamanho />} />
                <Route path="/config/tipo_impressao" element={<TipoImpressao />} />

                <Route path="/op" element={<IndexOp />} />

            </Routes>
        </Router>
    );
}

export default App;
